<div class="page-loader-wrapper">
  <div class="loader">
<!--      <div class="m-t-30"><img src="assets/images/logo.png" width="48" height="48" alt="Lucid"></div>-->
      <div class="m-t-30"><img src="../../../../assets/images/logo.png" width="87" height="26" alt="Lucid"></div>
      <p>Espere por favor...</p>
  </div>
</div>
